import { useRouter } from 'next/router';
import * as React from 'react';
import BookingEngineFormContainer from 'Components/widgets/booking-engine-form/BookingEngineForm.container';
import type { ProductBookingLineProps } from './ProductBookingLine.utils';
import { getBookingConfig } from './ProductBookingLine.utils';
export const ProductBookingLine = (props: ProductBookingLineProps) => {
  const { query } = useRouter();

  if (!props.resort) {
    return null;
  }

  const bookingConfig = getBookingConfig(props);
  return (
    <div className="Line Line-BookingEngine relative isolate z-6 overflow-hidden">
      <div className="PriceTicket-sticky-beacon" />
      <BookingEngineFormContainer
        bookingConfig={bookingConfig.booking}
        bookingCriteria={props.bookingCriteria}
        checkPriceLabel={props.checkPriceLabel}
        cmsPrice={bookingConfig.price}
        cmsStartingPrice={bookingConfig.resort.startingPrice}
        config={bookingConfig}
        enableTransfer={props.enableTransfer}
        i18n={{
          ...bookingConfig,
          checkPriceLabel: props.checkPriceLabel,
          errorMessageNoMorePackages: props.package.errorMessageNoMorePackages,
          errorMessageNoProposal: props.package.errorMessageNoProposal,
          legalInformations: props.legalInformations,
          package: props.package,
        }}
        legalInformations={props.legalInformations}
        package={props.package}
        pushImage={
          bookingConfig.booking.form.pushImage ? bookingConfig.booking.form.pushImage : null
        }
        queryParams={query}
        resort={props.resort}
        resortId={props.resortId}
        travelAdvisorConfig={bookingConfig.travelAdvisor}
      />
    </div>
  );
};
